export default __webpack_public_path__ + "static/blog-image-2-9e9125113190d1cdd89cf9bc1114e992.png";